
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'EditDialog',
  components: {}
})
export default class extends Vue {
  @Prop({
    default: () => {},
    required: true
  })
  editDialogData!: any;

  private rules: any = []
  created() {
    this.rules = {
      inputValue: this.editDialogData.rules
    };
  }

  confirm() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.$emit(this.editDialogData.callBack, this.editDialogData);
      } else {
        return false;
      }
    });
  }

  close() {
    this.editDialogData.visible = false;
    this.$emit('editDialogClose');
  }
}
